// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2f-2";
export var placeholderIcon = "_2f-3";
export var thumbnailCanvas = "_2f-1";
export var thumbnailWrapper = "_2f-0";